import { NavLink, useParams } from 'react-router-dom';
import clsx from 'clsx';
import { Typography } from '@la/ds-ui-components';
import styles from './SingleActivityViewNavigation.module.scss';

export default function SingleActivityViewNavigation({
  leagueProfileUrl = '',
}: {
  leagueProfileUrl: string;
}) {
  const params = useParams();
  const { programId, programType } = params;

  const userMenuData = [
    {
      path:
        programType === 'leagues'
          ? leagueProfileUrl
          : `/${programType}/${programId}`,
      id: 'profile',
      label: 'Profile',
    },
    {
      path: '',
      id: 'calendar',
      label: 'Calendar',
    },
    {
      path: `/${programType}/${programId}/standings`,
      id: 'standings',
      label: 'Standings',
    },
    {
      path: `/${programType}/${programId}?ai=ANNOUNCEMENTS`,
      id: 'announcements-messages',
      label: 'Announcements & Messages',
    },
  ];

  return (
    <div className={styles.navBar}>
      {userMenuData.map(({ id, label, path }) => {
        return (
          <NavLink
            to={path}
            key={id}
            id={id}
            className={({ isActive }) => {
              return clsx({
                [styles.navLinkItem]: true,
                [styles.active]: isActive,
              });
            }}
          >
            <Typography variant="ui" size="xl" weight="bold">
              {label}
            </Typography>
          </NavLink>
        );
      })}
    </div>
  );
}
